const DESCRIPTION_MAP = {
  'Bulk top-up by admin': 'Массовое пополнение администратором',
  'Admin adjustment': 'Корректировка администратором',
  'Service usage': 'Списание за генерацию',
  'Balance top-up': 'Пополнение баланса',
  'Protocol generation request': 'Генерация протокола',
  'Protocol generation from screenshot': 'Генерация из скриншота',
  'Refund: service did not return task ID': 'Возврат: сервис не вернул ID задачи',
  'Refund: service did not return task ID (screenshot)': 'Возврат: сервис не вернул ID задачи (скриншот)',
  'Refund for failed protocol generation': 'Возврат за неудачную генерацию протокола',
  'Refund for failed screenshot generation': 'Возврат за неудачную генерацию скриншота',
  'Refund: protocol generation failed': 'Возврат: ошибка генерации протокола',
};

const hasCyrillic = (text) => /[а-яА-ЯёЁ]/.test(text);

export function formatBalanceHistoryDescription(item) {
  const raw = (item.description || item.reason || '').trim();

  if (raw && DESCRIPTION_MAP[raw]) {
    return DESCRIPTION_MAP[raw];
  }

  if (raw && hasCyrillic(raw)) {
    return raw;
  }

  const operation = item.operationType || item.operation_type || item.type;
  const referenceType = item.referenceType || item.reference_type;
  const adminLogin = item.performedBy?.login;

  if (referenceType === 'manual') {
    if (operation === 'deposit') {
      return adminLogin
        ? `Пополнение администратором (${adminLogin})`
        : 'Пополнение администратором';
    }
    if (operation === 'withdrawal') {
      return adminLogin
        ? `Списание администратором (${adminLogin})`
        : 'Списание администратором';
    }
    return raw || 'Действие администратора';
  }

  if (referenceType === 'payment') {
    if (operation === 'deposit') return raw || 'Зачисление после оплаты пакета';
    if (operation === 'refund') return raw || 'Возврат по платежу';
  }

  if (referenceType === 'task' && operation === 'refund') {
    return raw || 'Возврат за услугу';
  }

  const byOperation = {
    payment: 'Списание за генерацию',
    deposit: 'Пополнение баланса',
    withdrawal: 'Списание',
    refund: 'Возврат',
    adjustment: 'Корректировка',
    generation: 'Генерация',
    generation_screenshot: 'Генерация из скриншота',
  };

  if (byOperation[operation]) {
    return raw || byOperation[operation];
  }

  return raw || '—';
}
